import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    margin: {
      type: String,
      default: '100px'
    }
  };

  static targets = ['source'];
  static requiredTargets = [];
  // TARGETS
  declare sourceTargets: HTMLSourceElement[];

  // VALUES
  declare marginValue: string;

  // STATE
  private observer: IntersectionObserver;

  connect(): void {
    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: this.marginValue
    });
    this.observer.observe(this.element);
  }

  disconnect(): void {
    this.observer.disconnect();
  }

  private onIntersection = (entries: IntersectionObserverEntry[]) => {
    if (entries.find((e) => e.isIntersecting)) {
      if (this.element instanceof HTMLVideoElement) {
        // In browsers that don't yet support this functionality,
        // playPromise won't be defined.
        const playPromise = this.element.play();

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Automatic playback started!
              this.element.play();
            })
            .catch(function (error) {
              // Automatic playback failed.
              // eslint-disable-next-line no-console
              console.log(error);
            });
        }
      }

      this.observer.disconnect();
    }
  };
}
